export default "__VITE_ASSET__EP1jb7IH__"